import React, { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import PageDescription from '../../PageDescription';
import BannerSingle from '../../BannerSingle';
import Lgpd from '../../Lgpd';
import DocumentLink from '../../DocumentLink';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';

class DemostracoesPage extends Component {
	render() {
		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<main>
					<ErrorBoundary><BannerSingle image={"demonstracoes-financeiras"} page={'demonstracoes-financeiras'} /></ErrorBoundary>
					{/* Page description */}
					<ErrorBoundary><PageDescription page={'demonstracoes-financeiras'} /></ErrorBoundary>


					{/* Content page */}
					<div className="_the-content page-planos pb-10">
						<div className='container'>
							<div className="row justify-content-center">

								<div className="col-md-10">
									<div className="row">
										<ErrorBoundary><DocumentLink  fileImg={'../../assets/img/Demonstrações Financeiras_Prancheta 1.png'} url={'ObterDemonstracaoFinanceira'} /></ErrorBoundary>


									</div>
								</div>
							</div>
						</div>
					</div>
				</main>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default DemostracoesPage;